import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=6998e786&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"
import style0 from "./Uploader.vue?vue&type=style&index=0&id=6998e786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998e786",
  null
  
)

export default component.exports